import About from "../../../components/about/About";
import Form from "../../../components/form/Form";
import React, { useContext } from "react";
import { getAbout, updateAbout } from "../../../apis/aboutApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingContext from "../../../context/LoadingContext";
import UserContext from "../../../context/UserContext";
import openSocket from "socket.io-client";
import getApiBaseUrl from "../../../utils/getApiBaseUrl";
function AboutPage(props) {
  const { token } = useContext(UserContext);
  const [state, setState] = useState({
    about: [],
    isLoading: null,
    errorMessage: null,
    editLoading: false,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadPosts();
    const socket = openSocket(getApiBaseUrl("http"));

    socket.on("about", (data) => {
      if (data.action === "update") {
        setState((prevState) => {
          return {
            ...prevState,
            about: [data.about],
          };
        });
      }
      return () => {
        socket.off("about");
        socket.disconnect();
      };
    });
  }, []);

  const loadPosts = async () => {
    setState((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });
    const { data, error } = await getAbout();
    console.log(data);
    if (error) {
      searchParams.delete("editmode");
      searchParams.delete("itemid");
      const newUrl = `${location.pathname}?${searchParams.toString()}`;

      navigate(newUrl);
      return setState((prevState) => {
        return {
          about: [],
          isLoading: false,
          editLoading: false,
          errorMessage: "Failed to load About.",
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        about: data.about,
        isLoading: false,
      };
    });
  };

  const startEditPostHandler = (id) => {
    console.log(state);
    searchParams.set("editmode", true);
    searchParams.set("itemid", id._id);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;

    navigate(newUrl);
  };

  const cancelEditHandler = () => {
    searchParams.delete("editmode");
    searchParams.delete("itemid");
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    console.log("test");
    setState((prevState) => {
      return {
        ...prevState,
        errorMessage: null,
      };
    });
    navigate(newUrl);
  };

  const finishEditHandler = async (aboutData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });

    const formData = new FormData();
    formData.append("content", aboutData.content);
    const { data, error } = await updateAbout(token, formData);

    if (error) {
      searchParams.delete("editmode");
      searchParams.delete("itemid");
      const newUrl = `${location.pathname}?${searchParams.toString()}`;

      navigate(newUrl);
      return setState((prevState) => {
        return {
          ...prevState,
          errorMessage: "Failed to edit About.",
          isLoading: false,
          editLoading: false,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: false,
      };
    });
    searchParams.delete("editmode");
    searchParams.delete("itemid");
    const newUrl = `${location.pathname}?${searchParams.toString()}`;

    navigate(newUrl);
  };
  console.log(state);
  return (
    <LoadingContext.Provider value={state.editLoading || state.isLoading}>
      <Error error={state.errorMessage} onHandle={cancelEditHandler} />

      <Form
        items={state.about}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <About onStartEdit={startEditPostHandler.bind(this, state.about[0])}>
        {state.isLoading ? (
          <span className="loading loading-spinner loading-lg"></span>
        ) : (
          state.about.map((item) => {
            return item.content;
          })
        )}
      </About>
    </LoadingContext.Provider>
  );
}

export default AboutPage;
